const SET_WX_CONFIG = 'SET_WX_CONFIG'

const SET_Ready_Keyword = 'SET_Ready_Keyword'

const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS'

export default {
    [SET_WX_CONFIG](state, wxConfig) {
        state.wxConfig = wxConfig
    },
    [SET_Ready_Keyword](state,readyKeyword){
        state.readyKeyword = readyKeyword
    },
    [SET_SEARCH_PARAMS](state,searchParams){
        state.searchParams = searchParams
    }
}




// WEBPACK FOOTER //
// ./src/vuex/mutations.js